export default __webpack_public_path__ + "static/media/ic-irr-flood.2fafce47.svg";